// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import LocalTime from "local-time"
LocalTime.start()
import { Collapse, Dropdown, Modal, Tab, Tooltip } from "bootstrap"
window.bootstrapCollapse = Collapse
window.bootstrapDropdown = Dropdown
window.bootstrapModal = Modal
window.bootstrapTab = Tab
// Initialize Bootstrap tooltips (per Bootstrap docs)
const initTooltips = () => {
  const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
  const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl))
}

const initNavbarToggle = () => {
  document.querySelectorAll('[data-navbar-toggle]').forEach((toggle) => {
    if (toggle.dataset.navbarToggleInitialized === 'true') return

    const input = document.getElementById(toggle.getAttribute('for'))
    if (!input) return

    const setExpanded = (expanded) => {
      input.checked = expanded
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false')
    }

    toggle.addEventListener('click', (event) => {
      event.preventDefault()
      setExpanded(!input.checked)
    })

    toggle.addEventListener('keydown', (event) => {
      if (event.key !== 'Enter' && event.key !== ' ') return

      event.preventDefault()
      setExpanded(!input.checked)
    })

    const navbar = toggle.closest('.app-navbar')
    navbar?.querySelectorAll('.app-navbar__link').forEach((link) => {
      link.addEventListener('click', () => setExpanded(false))
    })

    toggle.dataset.navbarToggleInitialized = 'true'
  })
}

document.addEventListener('turbo:load', initTooltips)
document.addEventListener('turbo:render', initTooltips)
document.addEventListener('turbo:load', initNavbarToggle)
document.addEventListener('turbo:render', initNavbarToggle)
